import React from "react";
import AuthBrand from "./AuthBrand";
import AuthFooter from "./AuthFooter";
import PlatformBenefitAlerts from "../components/PlatformBenefitAlerts";

const AuthLayout = ({ children, consentText, topContent, showBenefits = false }) => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#f4f6f7]">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(199,235,232,0.95),transparent_28%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(224,231,255,0.45),transparent_30%)]" />

      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-10">
        <div
          className={[
            "w-full",
            showBenefits ? "max-w-[980px]" : "max-w-[480px]",
          ].join(" ")}
        >
          <AuthBrand />
          {topContent}

          <div
            className={[
              showBenefits
                ? "grid grid-cols-1 items-stretch gap-6 lg:grid-cols-[1.05fr_0.95fr]"
                : "",
            ].join(" ")}
          >
            {showBenefits ? (
              <div className="order-2 lg:order-1 lg:self-center">
                <PlatformBenefitAlerts variant="auth" />
              </div>
            ) : null}

            <div className={showBenefits ? "order-1 lg:order-2" : ""}>
              <div className="rounded-[20px] bg-white px-8 py-10 shadow-[0_20px_60px_rgba(0,0,0,0.08)] sm:px-10 sm:py-11">
                {children}
              </div>
            </div>
          </div>

          <AuthFooter consentText={consentText} />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
